import React, { useEffect } from 'react'
import ForgotPasswordContent from 'src/components/Password/ForgotPasswordContent/ForgotPasswordContent'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'

const ForgotPasswordPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <ForgotPasswordContent />
      <Footer />
    </>
  )
}

export default ForgotPasswordPage
